<template>
    <main role="main">
        <article class="layout-contents-container">

            <div class="layout-page-title">
                <button class="buttons-icon" data-icon="back" data-type="line" type="button" v-on:click="goBack()">
                    Back
                </button>
                <h1 class="page-title">
                    {{ $t('MENU.COMPLIANCE') }}
                </h1>
            </div>

            <!--Compliance Title-->
            <div v-if="!pending" class="compliance-subtitle"
                 v-bind:data-type="getComplianceInfo.cmplStat === 'F' ? 'failer' : getComplianceInfo.cmplStat === 'P' ? 'success' : getComplianceInfo.cmplStat === 'E' ? 'failer' : 'waiting'">
                <div class="policy-item">
                    <div class="badge">
                        <!--검사 상태-->
                        <span v-if="getComplianceInfo.cmplStat === 'P'" class="icon-tag"
                              data-type="success">{{ $t('COMPLIANCE.EVAL_STAT.PASSED') }}<!--성공--></span>
                        <span v-else-if="getComplianceInfo.cmplStat === 'F'" class="icon-tag"
                              data-type="failer">{{ $t('COMPLIANCE.EVAL_STAT.FAILED') }}<!--실패--></span>
                        <span v-else-if="getComplianceInfo.cmplStat === 'R'" class="icon-tag" data-icon="examining"
                              data-type="waiting">{{ $t('COMPLIANCE.EVAL_STAT.EXAMINING') }}</span>
                        <span v-else-if="getComplianceInfo.cmplStat == null" class="icon-tag" data-icon="unexamined"
                              data-type="waiting">{{ $t('COMPLIANCE.EVAL_STAT.UNEXAMINED') }}</span>

                        <!--사용자 설정-->
                        <span v-if="getComplianceInfo.userDefiYn === 'Y'" class="icon-tag"
                              data-type="policy-custom">{{ $t('TYPE.CUSTOM') }}<!--사용자 설정--></span>
                        <span v-else-if="getComplianceInfo.userDefiYn === 'N'" class="icon-tag"
                              data-type="policy-system">{{ $t('TYPE.BEST_PRACTICE') }}<!--Best practice--></span>
                    </div>

                    <h2 class="name"
                        v-bind:title="getComplianceInfo.plcyTitl ? (getComplianceInfo.userDefiYn === constants.PARAM.SELECT.N ? getComplianceInfo[`${curLang}Title`] : getComplianceInfo.plcyTitl) : ''">
                        <span
                            class="ellipsis">{{
                                getComplianceInfo.plcyTitl ? (getComplianceInfo.userDefiYn === constants.PARAM.SELECT.N ? getComplianceInfo[`${curLang}Title`] : getComplianceInfo.plcyTitl) : ''
                            }}</span>
                        <a class="buttons" data-icon-right="open" data-size="s" data-type="line"
                           v-on:click="goPolicy()">
                            <span class="open">{{ $t('COMPLIANCE.MOVE_POLICY') }}<!--정책 수정 이동--></span>
                        </a>
                    </h2>
                    <span class="count">
                            <span v-if="getComplianceInfo.cmplStat === 'F'"
                                  class="error">{{
                                    $t('COMPLIANCE.POLICY_NAME_CONTENTS_FAIL', {'fCnt': getComplianceInfo.failCnt})
                                }} / </span>
                        <!--실패 n개-->
                            {{ $t('COMPLIANCE.POLICY_NAME_CONTENTS_TOTAL', {'tCnt': getComplianceInfo.ruleCnt}) }}
                        </span>
                </div>

                <div class="actions">
                    <time v-if="getComplianceInfo.execType === 'A'" class="scheduled" datetime="">
                        {{ $t('COMPLIANCE.LABEL.NEXT_EVALUEATION') }} {{ getComplianceInfo.reservedDate }}
                    </time>

                    <span class="seperate">
					<button class="buttons-icon" data-icon="more" data-tooltip-content="#tooltip-actions01"
                            data-trigger="management"
                            data-type="line"
                            type="button">{{ $t('LABEL.MANAGE') }}</button>

                        <!-- 관리 버튼 툴팁 메뉴 -->
					<div class="tooltip_templates">
						<div id="tooltip-actions01">
							<ul class="list-actions">
								<li>
									<button class="-btn" data-trigger="" type="button"
                                            v-on:click="removePolicyToCompliance"
                                            :disabled="getComplianceInfo.userDefiYn === 'N'">
                                        {{ $t('COMPLIANCE.BUTTON.REMOVE_FROM_EVAL_LIST') }}<!--검사 목록에서 제거--></button>
								</li>
							</ul>

						</div>
					</div>
				</span>
                </div>
            </div>

            <!--navigation bar-->
            <nav class="navigation-tab">
                <button class="tab-item " type="button"
                        v-bind:class="{'selected' : curTab === 'result'}"
                        v-on:click="changeTab('result')">{{ $t('COMPLIANCE.TAB.EVALUATION_RESULT') }}
                    <!--검사 결과--></button>
                <button class="tab-item" type="button"
                        :disabled="isFetching"
                        v-bind:class="{'selected' : curTab === 'info'}"
                        v-on:click="changeTab('info')">{{ $t('COMPLIANCE.TAB.POLICY_DETAILS') }}<!--정책 상세정보--></button>
                <button class="tab-item" type="button"
                        :disabled="isFetching"
                        v-bind:class="{'selected' : curTab === 'history'}"
                        v-on:click="changeTab('history')">{{ $t('COMPLIANCE.TAB.HISTORY') }}<!--이력(내역/기록)--></button>
            </nav>
            <!--contents-->
            <ComplianceDetailTabResult
                v-if="curTab === 'result'"
                :callDoComplianceDetail="doComplianceDetail"
                :callDoComplianceDetailV1="doComplianceDetailV1"
                :callSetSearchKey="setSearchKey"
                :callSetSortColumn="setSortColumn"
                :cmplDetail="cmplDetail"
                :doingInspection="doingInspection"
                :pending="pending"
                :ruleListData="ruleListData"
                :ruleListSearch="ruleListSearch"
                :sortColumn="sortColumn"
                :roleCode="roleCode"
                :evnet="roleCode"
            />
            <ComplianceDetailTabInfo
                v-else-if="curTab === 'info'"
                v-on:sheduleChange="handleScheduleChange"
            />
            <cmpl-detail-tab-history
                v-else-if="curTab === 'history'"
                v-bind:plcyId="this.getComplianceInfo.plcyId"
                v-bind:plcyRvsnId="this.getComplianceInfo.rvsnId">
            </cmpl-detail-tab-history>
        </article>
        <div-loading v-if="pending" :full="true"></div-loading>
        <pop-send-report
            :userList="cmplDetail.userList"
        />
        <Modal
            ref="singleActionModal"
            :message="deleteMessage"
            :okFunction="handleActionModal"
            :title="deleteTitle"
            btnOkStyle="danger"
        />
        <CustomModal
            :isShowPopup="customModal.isShowPopup"
            btn1-txt="Cancel"
            btn2-txt="Save"
            btn3-txt="Run"
            :curLang="curLang"
            title="Manual Assessment"
            message="Assessment with manual rules."
            :callOnHide="onHideCustomModal"
            :callAction3="runAssessment"
            :callAction2="saveAndRunManualAssessment"
        >
            <template slot=body-template>
                <ManualRuleList
                    class="mt-4"
                    :ruleList="manualRules"
                    :getSelectedRules="getSelectedRules"
                />
            </template>
        </CustomModal>
    </main>
</template>
<script>
    import ComplianceDetailTabResult from "./complianceDetailTabResult.vue";
    import ComplianceDetailTabInfo from "./complianceDetailTabInfo.vue";
    import CompliaceDetailTabHistory from "./complianceDetailTabHistory.vue";
    import PopSendReport from "../common/popSendReport.vue";
    import _ from "lodash";
    import {mapGetters, mapMutations} from "vuex";
    import Modal from "../common/Modals/Modal.vue";
    import CustomModal from "../common/Modals/CustomModal.vue";
    import ManualRuleList from "./components/ManualRuleList.vue";
export default {
    name: 'ComplianceDetail',
    components: {
        ComplianceDetailTabResult, ComplianceDetailTabInfo, Modal,
        CustomModal, ManualRuleList,
        'cmpl-detail-tab-history': CompliaceDetailTabHistory,
        'pop-send-report': PopSendReport,
    },
    data() {
        return {
            intgId: this.$route.query.rslt,           // Compliance Result ID
            cmplId: this.$route.query.cmpl,            // Compliance ID
            rsltId: this.$route.query.rslt,           // Compliance Result ID
            isNewAssessment: false,
            isFetching: false,
            selectedRules: [],
            customModal: {
                isShowPopup: false
            },
            curTab: null
            , ruleInfo: {}                            // Checked rule list
            , pending: false
            , searchStat: this.constants.PARAM.SELECT.FILTER_ALL      // SearchList of Compliance Status : 처음 전체선택으로 모든 값 넣어줌
            , searchSvrty: this.constants.PARAM.SELECT.SEARCH_SEVERITY                     // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
            , sortColumn: ''
            , cmplDetail: {}
            , ruleListData: []
            , ruleListSearch: []
            , cmplSearchKey: {}
            , doingInspection: false
            , doingManualRule: false
            , deleteMessage: ""
            , deleteTitle: "",
            INTERVAL_LIMIT: 15,
            intvlCnt: 0,
            roleCode: null,
            eventSource: null,
            eventSourceId: '',

        }
    },
    created: function () {
        this.getHistoryInfo();
        this.selectActionTemplateList();
        this.getAccountList();
        this.selectUserList();
        this.debounceGetRuleByKey = _.debounce(this.getRuleByKey, 500);

    },
    mounted() {
        this.slctCmplInfo('complianceDetailTabResult');
        this.slctCmplInfo();
        this.getAlertCreatePermission();
        this.initSse();
    },
    computed: {
        curLang() {
            return this.$i18n.locale;
        },
        ...mapGetters({
            curCmpnId: 'user/curCmpnId',
            complianceHistory: 'user/complianceHistory',
            siteCd: 'user/siteCd',
            loginUser: 'user/loginUser',
            sseEventSource: 'sse/sseEventSource',
            sseResponseData: 'sse/sseResponseData',
            isSseEventSourceClosed: 'sse/isSseEventSourceClosed',
            lastEventId: 'sse/lastEventId'
        }),
        manualRules() {
            return this.getManualRules(this.ruleListData);
        },
        getComplianceInfo: function () {
            return this.ruleInfo || {};
        },
        templateList: function () {
            return this.$store.state.templateList;
        },
    },
    watch: {
        ruleListData(newVal){
            this.isFetching = false;
            if (!this.isNewAssessment) {
                this.getCtgLabelFilterData(newVal);
                if (this.templateList) {
                    this.getProdFilterData(newVal);
                }
                newVal.forEach(rule => {
                    if (!rule.cndVal) {
                        this.isFetching = false;
                    } else if (rule.ruleCmplRslt == null || rule.ruleCmplRslt == 'R') {
                        this.isFetching = true;
                    }
                });
                if (!this.isFetching) {
                    this.cancelAutoUpdate();
                    this.isFetching = false;
                    this.doingInspection = false;
                }
            } else {
                this.isFetching = false;
                this.doingInspection = false;
                this.cancelAutoUpdate();
            }
        },
        intvlCnt(cnt) {
            if (cnt >= this.INTERVAL_LIMIT) {
                this.intvlCnt = 0;
                this.cancelAutoUpdate();
                this.doingInspection = false;
                location.reload();
            }
        },
        templateList() {
            if (this.ruleListData) {
                this.getProdFilterData(this.ruleListData);
            }
        },
        curCmpnId: function () {
            this.$router.push("/compliance");
        },
        sseResponseData(newVal) {
            if (newVal.indexOf('_complete') !== -1 && newVal.includes(this.cmplId)) {
                this.fetchCmplDetail();
            }
        },
        isSseEventSourceClosed: function() {
            this.fetchCmplDetail();
        }
    },
    methods: {
        ...mapMutations({
            setAssessmentStatus: "user/setAssessmentStatus"
        }),
        getHistoryInfo() {
            if (this.complianceHistory.isOnInspection) {
                this.doingInspection = true;
            }
        },
        fetchCmplDetail() {
            this.intvlCnt += 1;
            this.slctCmplInfo('complianceDetailTabResult');
            this.slctCmplInfo();
            if (this.complianceHistory.isOnInspection) {
                this.setAssessmentStatus(false);
            }
        },
        getSelectedRules(rules) {
            this.selectedRules = rules;
        },
        reloadComplianceDetailPage(result) {
            if (_.isEmpty(result)) {
                this.slctCmplInfo('complianceDetailTabResult');
            } else {
                const url = "/compliance/detail";
                this.$router.push({path: url, query: {cmpl: result.cmplId, rslt: result.rsltId}});
            }
        },
        async runAssessment() {
            // do Auto Assessment first to genarate the intg_id
            this.doingManualRule = true;
            const mRules = this.selectedRules;
            var doComplianceDetailAutoTask =  this.doComplianceDetailAuto();
            var saveAndRunManualAssessmentTask=  this.saveAndRunManualAssessment(mRules);
            await doComplianceDetailAutoTask;
            await saveAndRunManualAssessmentTask;
        },
        saveAndRunManualAssessment(mRules) {
            this.pending = true;
            this.doingManualRule = true;
            let rules;
            if (mRules) {
                rules = this.getManualRuleById(mRules);
            } else {
                rules = this.getManualRuleById(this.selectedRules);
            }
            const url = "/api/governance/cmpl/rule/manual/edit";
            const reqData = {
                intgId: this.intgId,
                plcyId: this.getComplianceInfo.plcyId,
                rules
            };
            this.http.post(url, reqData)
                .then(response => {
                    this.doingManualRule = false;
                    this.pending = false;
                });
        },
        getManualRuleById(selectedIds) {
            self = this;
            let rules = [];
            _.forEach(this.manualRules, (rule)=>{
                const ruleId = rule.ruleId;
                let cmpl = _.get(selectedIds, ruleId);
                if (cmpl === undefined) {
                   cmpl = rule.ruleCmplRslt === 'P';
                }
                rules.push({
                    ruleId: ruleId,
                    cmpl,
                    ...rule,
                });
            });
            return rules;
        },
        openAssessmentModal() {
            this.customModal = {
                isShowPopup: true,
            }
        },
        onHideCustomModal() {
            this.customModal.isShowPopup = false;
            this.selectedRules = [];
        },
        getManualRules(ruleListData) {
            let manualRules = [];
            _.forEach(ruleListData, (rule)=>{
                if (rule.autoExeYn === "N") {
                    manualRules.push(rule);
                }
            });
            return manualRules;
        },
        doComplianceDetail: function(){
            if (this.manualRules.length > 0) {
                this.openAssessmentModal();
            }else{
                this.doingManualRule = false;
                this.doComplianceDetailAuto();
            }
        },
        doComplianceDetailV1: function(){
            if (this.manualRules.length > 0) {
                this.openAssessmentModal();
            }else{
                this.doingManualRule = false;
                this.doComplianceDetailAutoV1();
            }
        },
        doComplianceDetailAuto() {
            const url = "/api/governance/sprint7/compliance";
            const uuid = this.Common.uuid();
            this.rsltId = uuid;
            this.intgId = uuid;
            const reqData = {
                'rsltId': this.rsltId,
                'cmpnId': this.curCmpnId,
                'cmplId': this.getComplianceInfo.cmplId,
                'plcyId': this.getComplianceInfo.plcyId,
                'rvsnId': this.getComplianceInfo.rvsnId,
                'ruleListInfo': this.ruleListData,
            }
            try {
                this.setAssessmentStatus(true);
                this.http.post(url, reqData);
                const cmplInfo = {rsltId: this.rsltId, cmplId: this.getComplianceInfo.cmplId};
                this.reloadComplianceDetailPage(cmplInfo);
            } catch (err) {
                console.error("doComplianceDetailAuto: ", err);
            } finally {
                // TODO
            }
        },
        doComplianceDetailAutoV1() {
            const url = "/api/governance/compliance/v1";
            const uuid = this.Common.uuid();
            this.rsltId = uuid;
            this.intgId = uuid;
            const reqData = {
                'rsltId': this.rsltId,
                'cmpnId': this.curCmpnId,
                'cmplId': this.getComplianceInfo.cmplId,
                'plcyId': this.getComplianceInfo.plcyId,
                'rvsnId': this.getComplianceInfo.rvsnId,
                'ruleListInfo': this.ruleListData,
            }
            try {
                this.setAssessmentStatus(true);
                this.http.post(url, reqData);
                const cmplInfo = {rsltId: this.rsltId, cmplId: this.getComplianceInfo.cmplId, cmpnId: this.curCmpnId};
                this.reloadComplianceDetailPage(cmplInfo);
            } catch (err) {
                console.error("doNewComplianceDetailAuto: ", err);
            } finally {
                // TODO
            }
        },
        getAccountList: function () {
            let url = `/api/governance/cmpl/target/acnt`;
            let header = {
                "cmpnId": this.curCmpnId,
                "cmplId": this.$route.query.cmpl
            };
            this.http.post(url, JSON.stringify(header))
                .then(result => {
                    if (result.status === 200) {
                        let cmplDetail = {...this.cmplDetail};
                        cmplDetail.acntList = result.data.result.list ? result.data.result.list : [];
                        cmplDetail.acntListCnt = result.data.result.cnt;
                        this.cmplDetail = cmplDetail;
                        this.getRuleByKey();
                    }
                });
        },
        getProdFilterData: function (ruleListData) {
            let prodFilter = [];
            let haveManual = false;
            if (ruleListData && this.templateList) {
                ruleListData.forEach((rule)=>{
                    if (rule.autoExeYn === "Y") {
                        const conditions = rule.cndVal;
                        conditions.forEach((cnd)=>{
                            const ruleProd = _.find(this.templateList, {'tmpltId': cnd.tmpltId});
                            if (ruleProd) {
                                const val = this.$t('PRODUCT.' + ruleProd.prod);
                                const vendor = this.Common.getVendorByKey(ruleProd.vendor);
                                prodFilter.push({
                                    key: ruleProd.prod,
                                    val, vendor
                                });
                            }
                        })
                    } else {
                        haveManual = true;
                    }
                });
            }
            if (haveManual) {
                const manualProduct = {
                    key: 'manual',
                    val: this.$t('LABEL.MANUAL_RULE')
                }
                prodFilter.push(manualProduct);
            }
            const cmplDetail = {...this.cmplDetail};
            cmplDetail.prodFilterData = _.unionBy(prodFilter, 'key');
            this.cmplDetail = cmplDetail;
        },
        getCtgLabelFilterData: function (ruleListData) {
            let ctgFilter = [];
            ruleListData.forEach(function (r) {
                if (!_.isNil(r.ctgLabel)) {
                    for (let ctg of r.ctgLabel) {
                        ctgFilter.push({key: ctg, val: ctg});
                    }
                }
            })
            let cmplDetail = {...this.cmplDetail};
            cmplDetail.ctgLabelFilterData = _.unionBy(ctgFilter, 'key');
            this.cmplDetail = cmplDetail;
        },
        // 선택한 Column으로 Rule 리스트 Sorting
        setSortColumn(sortColumn) {
            const sortObject = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
            this.sortColumn = sortObject.sortColumn;
            this.sortOrder = sortObject.sortOrder;
            this.getRuleByKey();
        },
        setSearchKey(key, value) {
            this.cmplSearchKey = {
                ...this.cmplSearchKey,
                [key]: value
            };
            this.getRuleByKey();
        },
        async slctCmplInfo(api) {
            let url = '';
            var header = {
                'cmpnId': this.curCmpnId,
                'cmplId': this.cmplId,
                'rsltId': this.rsltId
            }
            if (api && api === 'complianceDetailTabResult') {
                url = `/api/governance/compliance/result`;
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        let cmplDetail = {...this.cmplDetail};
                        this.ruleListData = result.data.result;
                        cmplDetail.rsltId = this.rsltId;
                        cmplDetail.cmplId = this.cmplId;
                        for (let rule of this.ruleListData) {
                            rule.cndVal = rule.cndVal !== null ? JSON.parse(rule.cndVal) : null
                            rule.actnVal = rule.actnVal !== null ? JSON.parse(rule.actnVal) : null
                            rule.accAlias = rule.accAlias !== null ? rule.accAlias.split(',') : null
                            rule.ctgLabel = rule.ctgLabel !== null ? rule.ctgLabel.split("|") : null
                        }
                        //init search keys
                        cmplDetail.searchTxt = "";
                        cmplDetail.searchCtg = [];
                        cmplDetail.searchProd = [];
                        this.cmplDetail = cmplDetail;
                        if (this.Common.isEmptyText(cmplDetail.rsltId)) {
                            this.isNewAssessment = true;
                        } else {
                            this.isNewAssessment = false;
                        }
                        this.getRuleByKey();
                    });
            } else {
                url = "/api/governance/compliance/info";
                try {
                    const result = await this.http.post(url, JSON.stringify(header));
                    this.ruleInfo = result.data.result;
                    this.$nextTick(function () {
                        this.curTab = 'result';
                        let self = this;
                        setTimeout(function () {
                            self.initView();
                        }, 10);
                    });
                } catch (err) {
                    console.error("Get rule info: ", err);
                }
            }
        },
        getRuleByKey() {
            const {searchTxt, searchProd, searchCtg} = this.cmplSearchKey;
            const self = this;
            // Search를 위해 원본 Response 데이터는 유지하여 cloneDeep copy
            let listInfo = _.cloneDeep(this.ruleListData);
            if (!listInfo[0] || listInfo[0].cndVal == null) { // rule 등록되지 않은 것 처리
                return [];
            }
            listInfo = _.forEach(listInfo, function (o) {
                _.forEach(o.cndVal, function (k) {
                    let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                    if (typeof (ruleProd) !== 'undefined') {
                        // o.prodNm = self.$t('PRODUCT.'+ruleProd.prod)
                        o.prodNm = ruleProd.prod
                    }

                })
            })
            /* Filter 처리 */
            // Text filter
            if (typeof (searchTxt) !== 'undefined' && searchTxt !== '') {
                try {
                    listInfo = listInfo.filter(item => {
                        let ruleTitle = item[`${this.curLang}RuleTitle`];
                        if (ruleTitle) {
                            ruleTitle = item[`${this.curLang}RuleTitle`].toLocaleLowerCase();
                        } else {
                            ruleTitle = item.ruleTitl;
                        }
                        ruleTitle = ruleTitle.toLocaleLowerCase();
                        return ruleTitle.includes(searchTxt.toLocaleLowerCase())}
                    );
                } catch (err) {
                    console.error("complianceDetail: ", err);
                }
            }
            // Category filter
            if (typeof (searchCtg) !== 'undefined' && searchCtg.length > 0) {
                listInfo = _.filter(listInfo, function (o) {
                    for (let srchCtg of searchCtg) {
                        if (_.includes(o.ctgLabel, srchCtg)) {
                            return true
                        }
                    }
                    return false
                })
            }
            // Product filter
            if (typeof (searchProd) !== 'undefined' && searchProd.length > 0) {
                let manualRules = [];
                if (searchProd.includes('manual')) {
                    manualRules = _.cloneDeep(_.filter(listInfo, {'autoExeYn': 'N'}));
                }
                listInfo = _.filter(listInfo, function (o) {
                    let fill = _.filter(o.cndVal, function (k) {
                        let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                        for (let srchProd of searchProd) {
                            if (ruleProd && ruleProd.prod === srchProd) {
                                return true;
                            }
                        }
                        return false;
                    });
                    return fill.length > 0;
                })
                listInfo = listInfo.concat(manualRules);
            }
            // 검사 상태별 필터 선택 시
            if (this.searchStat.length !== this.constants.COMPLIANCE_STAT_FILTER.length) {
                listInfo = listInfo.filter((p) => {
                    let value = false;
                    // 실패(해결됨)
                    if (_.includes(this.searchStat, this.constants.COMPLIANCE_STAT.FAIL_SOLVED)) {
                        if (p.ruleCmplRslt === this.constants.COMPLIANCE_STAT.FAIL && p.execYn === 'Y') {
                            value = true;
                        }
                    }
                    // 실패(미해결)
                    if (_.includes(this.searchStat, this.constants.COMPLIANCE_STAT.FAIL_UNSOLVED)) {
                        if (p.ruleCmplRslt === this.constants.COMPLIANCE_STAT.FAIL && p.execYn === 'N') {
                            value = true;
                        }
                    }
                    // 나머지 case
                    if (_.includes(this.searchStat, p.ruleCmplRslt)) {
                        value = true;
                    }
                    return value;
                })
            }
            // 심각도 필터 선택 시
            if (this.searchSvrty.length !== this.constants.SVRTY_FILTER.length) {
                listInfo = listInfo.filter((p) => {
                    return _.includes(this.searchSvrty, p.svrty)
                })
            }

            // Sorting 처리
            if (this.sortColumn !== '' && this.sortOrder !== '') {
                listInfo = _.orderBy(listInfo, [self.sortColumn], [self.sortOrder])
            }

            if (listInfo !== null) {
                this.searchCnt = listInfo.length
            }

            // Action 없는 Rule 처리
            _.forEach(listInfo, function (rule) {
                _.forEach(rule.actnVal, function (actn) {
                    if (actn.actnId !== null && actn.actnId !== self.constants.PARAM.SELECT.NONE) {
                        rule.availAction = true
                        return false
                    }
                })
            })
            this.ruleListSearch = listInfo;
        },
        // Action 목록 조회
        selectActionTemplateList() {
            // Action List 초기화
            var url = `/api/governance/actn`;
            this.http.get(url)
                .then(response => {
                    let cmplDetail = {...this.cmplDetail};
                    cmplDetail.actionTemplateList = response.data.result;
                    this.cmplDetail = cmplDetail;
                });
        },
        // Action Email 에서 사용할 사용자 List 가져오기
        selectUserList() {
            var url = `/api/governance/user/list`;
            var header = {
                'cmpnId': this.curCmpnId
            };

            this.http.post(url, header)
                .then(response => {
                    if (response.data.status === 'ok') {
                        let cmplDetail = {...this.cmplDetail};
                        cmplDetail.userList = response.data.result;
                        this.cmplDetail = cmplDetail;
                    }
                });
        },
        changeTab: function (tab) {
            this.curTab = tab;
        },

        downloadReport: function () {
            // TODO : 하나의 compliance만 report 보내도록 수정 필요
            this.Common.viewPopup('popup-send-report-email');
        },
        goBack() {
            this.$router.replace('/compliance');
        },
        // 해당 Policy Management 화면으로 이동
        goPolicy() {
            const url = "/policy/detail";
            this.$router.push({path: url, query: {rvsn: this.getComplianceInfo.rvsnId}});
        },
        initView: function () {
            // 복사/삭제/히스토리보기 ... 메뉴 Script
            var $moreActions = $('[data-trigger="management"]');
            $moreActions.tooltipster({
                animation: 'fade',
                side: 'bottom',
                theme: 'go-actions',
                interactive: true,
                trigger: 'click',
                arrow: false,
                functionBefore: function (instance, helper) {
                    $(helper.origin).addClass("selected");
                },
                functionAfter: function (instance, helper) {
                    $(helper.origin).removeClass("selected");
                },
                functionPosition: function (instance, helper, position) {
                    position.coord.top = position.coord.top -= 7;
                    position.coord.left = helper.geo.origin.offset.right - position.size.width;
                    return position;
                }
            });
        },
        async handleActionModal() {
            const data = {
                cmpnId: this.curCmpnId,
                cmplList: [this.getComplianceInfo]
            };
            const url = '/api/governance/compliance/remove';
            const response = await(this.http.post(url, data));
            if (response.data.status === 'ok') {
                this.$router.push('/compliance');
            }
        },
        removePolicyToCompliance() {
            this.deleteTitle = this.$t('COMPLIANCE.POPUP.TITLE.REMOVE_FROM_EVAL_LIST');
            this.deleteMessage = this.$t('COMPLIANCE.POPUP.DESC.REMOVE_FROM_EVAL_LIST');
            this.$refs.singleActionModal.showPopup();
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        },
        handleScheduleChange(execType, reservedDate) {
            if (this.ruleInfo) {
                this.ruleInfo.execType = execType;
                if (reservedDate) {
                    this.ruleInfo.reservedDate = reservedDate;
                }
            }
        },
        async getAlertCreatePermission() {
            const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}/role`;
            const response = await this.http.get(url);

            const roleCode = _.get(response, "data.data.roleCode");
            this.roleCode = roleCode;
        },
        initSse() {
            let payload = {
                cmpnId : this.curCmpnId,
                menuName : 'compliance'
            }
            if (!this.sseEventSource) {
                this.$store.dispatch('sse/createSseEventSource', payload);
            }
        },
    },
    beforeDestroy() {
        $('body').removeClass('compliance');
        this.cancelAutoUpdate();
    }
}
</script>
<style scoped>
.buttons[data-type=line]{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/complianceDetail.vue